<template>
  <div id="app">

    <div id="header">
      <div class="head-wrap">
        <h2  @click="click('main-visual')" ontouchstart="">
          <picture>
            <source srcset="@/assets/img/pc/img_logo.svg" media="(min-width: 681px)" />
            <source srcset="@/assets/img/sp/img_logo.svg" media="(max-width: 680px)" />
            <img src="@/assets/img/pc/img_logo.svg" alt="">
          </picture>
        </h2>
        <p class="sp-none">長野県上田市のホームページ制作/Webシステム開発</p>
      </div>
    </div>

    <router-view/>

    <div id="footer">
    <div class="footer-wrap">
      <div class="company-info">
        <div class="logo">
          <picture>
            <source srcset="@/assets/img/pc/img_logo_wh.svg" media="(min-width: 681px)" />
            <source srcset="@/assets/img/sp/img_logo_wh.svg" media="(max-width: 680px)" />
            <img src="@/assets/img/pc/img_logo_wh.svg" alt="">
          </picture>
        </div>
        <p class="company-name">株式会社Seekcloud</p>
        <p class="address sp-none">長野県上田市材木町2-9-4 YCCビル 2F<br>TEL：0268-71-0740  FAX：0268-71-0752<br>9：00～18：00 （土日祝休）</p>
        <p class="address pc-none">長野県上田市材木町2-9-4 YCCビル 2F<br>TEL：0268-71-0740<br>FAX：0268-71-0752<br>9：00～18：00 （土日祝休）</p>
      </div>
      <div class="footer-nav sp-none">
        <ul>
          <li><a @click="click('main-visual')">TOP</a></li>
          <li>ー<a @click="click('reason')">&nbsp;選ばれる3つのポイント</a></li>
          <li>ー<a @click="click('online-advertisement')">&nbsp;オンライン広告とは</a></li>
          <li>ー<a @click="click('merit')">&nbsp;オンライン広告のメリット</a></li>
          <li>ー<a @click="click('service')">&nbsp;取り扱い商品一覧</a></li>
          <li>ー<a @click="click('case')">&nbsp;事例</a></li>
          <li>ー<a @click="click('flow')">&nbsp;掲載開始までの流れ</a></li>
          <li>ー<a @click="click('price')">&nbsp;料金について</a></li>
          <li>ー<a @click="click('faq')">&nbsp;よくあるご質問</a></li>
          <li>ー<a @click="click('contact')">&nbsp;お問い合わせ</a></li>
        </ul>
      </div>
    </div>
  <div class="copyright">Copyright © 2020 Seekcloud Inc. All Rights Reserved.</div>
  </div>
  
  </div>
</template>

<script>
export default {

  methods: {

    click: function(id) {
      if(this.$route.path === "/"){
        let to = document.getElementById(id);
        let top = to.offsetTop;
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        })
      } else{
        this.$router.push({
        name: 'Top',
        params: {
          id: id
        }
      })
      }

        
        
      
    }

  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#footer{
  .footer-nav{
    ul{
      li{
        text-align: left;
      }
    }
  }
}
</style>
